import "./App.css";
import Header from "./components/Header";
import {Route, Routes, useLocation} from "react-router-dom";
import {TransitionGroup, CSSTransition} from "react-transition-group";

import Home from "./pages/Home";
import People from "./pages/People";
import Publications from "./pages/Publications";
import Research from "./pages/Research";
import Facility from "./pages/Facility";
import Album from "./pages/Album";
import Contact from "./pages/Contact";

function App() {
  const location = useLocation();

  return (<div className="App">
    <Header/>
    <TransitionGroup>
      <CSSTransition
        key={location.key} // 각 위치에 고유한 키를 부여하여 전환을 처리
        classNames="fade" // CSS 클래스 이름
        timeout={500} // 애니메이션 지속 시간
      >
        <Routes location={location}>
          <Route path="/" element={<Home/>}/>
          <Route path="/people" element={<People/>}/>
          <Route path="/publications" element={<Publications/>}/>
          <Route path="/research" element={<Research/>}/>
          <Route path="/facility" element={<Facility/>}/>
          <Route path="/album" element={<Album/>}/>
          <Route path="/contact" element={<Contact/>}/>
        </Routes>
      </CSSTransition>
    </TransitionGroup>
  </div>);
}

export default App;
